import { getPlanStatus, updatePayment, getInvoiceList, getPendingInvoiceList, postPendingCreditCard, changeInvoiceStatusToOpen } from 'Api/subscriptionApi'
import { parsePlanStatus, parseInvoice } from 'Parsers/subscriptionParser'
import { SubscriptionState } from 'Types/_Store/CompanyAccount'
import paymentTypes from 'Enums/paymentTypes'

const state: SubscriptionState = {
  requesting: {
    invoiceList: false,
    invoice: false,
    status: false,
    updatePay: false,
    pendingInvoiceList: false,
    overduePay: false,
    changeInvoiceStatus: false,
    pendentCreditCard: false
  },

  pagination: {
    current: 1,
    limit: 1,
    pageSize: 3,
  },

  paymentInfo: {
    method: null,
    cardId: null,
  },

  status: {
    planName: '',
    amount: '',
    period: '',
    nextInvoice: '',
    paymentMethod: '',
    creditCard: null,
    billing: null,
    bonusAmount: 0,
    displayAlert: '',
    container: null
  },

  invoiceList: [],

  pendingInvoiceList: {
    amountOriginal: 0,
    amount: 0,
    invoices: []
  }
}

const getters = {
  hasMoreInvoices: state => state.pagination.current < state.pagination.limit,
}

const mutations = {
  request_start(state, type) {
    state.requesting[type] = true
  },

  request_success(state, type) {
    state.requesting[type] = false
  },

  request_failure(state, type) {
    state.requesting[type] = false
  },

  set_payment_info(state, paymentInfo) {
    Object.assign(state.paymentInfo, paymentInfo)
  },

  set_subscription_status(state, status) {
    Object.assign(state.status, status)
  },

  set_invoice_list(state, invoiceList) {
    state.invoiceList = invoiceList
  },

  set_pagination(state, pagination) {
    Object.assign(state.pagination, pagination)
  },

  set_display_alert(state, displayAlert){
    state.status.displayAlert = displayAlert
  },

  set_pendent_invoice_list(state, pendentInvoice) {
    state.pendingInvoiceList = pendentInvoice
  },

}

const actions = {
  async getPlanStatus({ commit }) {
    commit('request_start', 'status')

    try {
      const { data } = await getPlanStatus()
      const status = parsePlanStatus(data)

      commit('set_subscription_status', status)
      commit('request_success', 'status')

      return true
    } catch (err) {
      commit('request_failure', 'status')

      throw err
    }
  },

  async updatePlanPayment({ commit, state }, paymentValue) {
    commit('request_start', 'updatePay')

    try {
      const { selectedCardId, selectedPix } = paymentValue
      const method = selectedCardId ? paymentTypes.creditCard : (selectedPix ? paymentTypes.pix : paymentTypes.boleto);
      const result = await updatePayment(method, selectedCardId)

      commit('request_success', 'updatePay')

      return result
    } catch (err) {
      commit('request_failure', 'updatePay')

      throw err
    }
  },

  async getInvoiceList({ commit, state }) {
    commit('request_start', 'invoiceList')

    try {
      const { page, pageSize } = state.pagination

      const { data } = await getInvoiceList(page, pageSize)
      const invoiceList = data.items.map(parseInvoice)

      const current = data.page
      const limit = Math.ceil(data.totalCount / data.pageSize)
      commit('set_pagination', { current, limit })

      commit('set_invoice_list', invoiceList)
      commit('request_success', 'invoiceList')

      return data
    } catch (err) {
      commit('request_failure', 'invoiceList')

      throw err
    }
  },

  loadMoreInvoices({ dispatch, commit, state }) {
    const pageSize = state.pagination.pageSize + 3

    commit('set_pagination', { pageSize })
    dispatch('getInvoiceList')
  },

  updatePaymentInfo({ commit }, paymentInfo) {
    commit('set_payment_info', paymentInfo)
  },

  async getPendingInvoiceList({ commit }) {
    try {
      const { data } = await getPendingInvoiceList()

      commit('set_pendent_invoice_list', data)

      return data
    } catch (err) {
      throw err
    }
  },

  async postPendentCreditCard({ commit }, cardId: number) {
    commit('request_start', 'pendentCreditCard')
    try {
      const { data } = await postPendingCreditCard(cardId)
      commit('request_success', 'pendentCreditCard')

      return data
    } catch (err) {
      commit('request_failure', 'pendentCreditCard')

      throw err
    }
  },

  async changeInvoiceStatus({ commit }) {
    commit('request_start', 'changeInvoiceStatus')

    try {
      const { data } = await changeInvoiceStatusToOpen()
      commit('request_success', 'changeInvoiceStatus')

      return data
    } catch (err) {
      commit('request_failure', 'changeInvoiceStatus')
      throw err
    }
  },
}

export default {
  namespaced: true,

  state,
  getters,
  mutations,
  actions,
}